import React, { memo } from "react";

const Footer = ({ configureData }) => {
  return (
    <footer className="page-footer">
      <div className="container">
        <div className="col-md-12 text-center">
          <p className="text-white mb-0">
            Questions about your options or the coverage details? Give us a
            call:{" "}
            <a
              className="text-white"
              href={`tel:${(configureData.theme?.helpLineNumber).replace(
                /-/g,
                ""
              )}`}
            >
              {" "}
              {configureData.theme.helpLineNumber}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
export default memo(Footer);
